
































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import StatsTableLayout from '@/components/layout/StatsTableLayout.vue';
import {Getter} from 'vuex-class';
import {FOCUS_GAME_TYPE_ID, FOCUS_LEAGUE_ID, FOCUS_SEASON_ID} from '@/store/context.store';
import COMMON_UTIL from '@/utils/common.util';
import Player from '@/model/core/player.model';
import {GameTypeId, LeagueId} from '@/model/core/core-data.model';
import PLAYER_SERVICE from '@/services/player.service';
import StatsSeasonSelection from '@/components/stats/selection/StatsSeasonSelection.vue';
import DataTable from '@/components/stats/DataTable.vue';

@Component({
  components: {DataTable, StatsTableLayout, StatsSeasonSelection},
})
export default class PlayerPage extends Vue {

  @Prop({required: true}) playerId!: string;

  @Getter(FOCUS_SEASON_ID) focusSeasonId!: string;
  @Getter(FOCUS_GAME_TYPE_ID) focusGameTypeId!: GameTypeId;
  @Getter(FOCUS_LEAGUE_ID) focusLeagueId!: LeagueId;
  // TODO selectedHomeAway,

  seasonSelection = StatsSeasonSelection;

  loaded = false;
  player?: Player = undefined;
  origLeague?: LeagueId = undefined;
  origGameType?: GameTypeId = undefined;

  @Watch('playerId')
  onPlayerIdChanged() {
    this.loadPlayer();
  }

  created() {
    this.loadPlayer();
  }

  beforeDestroy() {
    // TODO beforeDestroy
    // this.selectLeagueId(this.origLeague);
    // this.selectGameTypeId(this.origGameType);
  }

  get playerImageUrl() {
    // TODO handle 404
    return COMMON_UTIL.links.playerPortrait(this.playerId);
  }

  get playerName() {
    if (this.player) {
      return this.player.name();
    }
    return '';
  }

  get currentTeamId() {
    if (this.player) {
      return this.player.currentTeamId;
    }
    return '';
  }

  get position() {
    if (this.player) {
      return this.$t(`position.${this.player.position}`);
    }
    return '';
  }

  get title() {
    if (this.player) {
      return `Statistiken von ${this.playerName}`;
    }
    return '';
  }

  get nationalities() {
    if (!this.player) {
      return [];
    }
    const result = [];
    if (this.player.nationalityId1) {
      result.push(this.$t(`country.${this.player.nationalityId1}`));
      result.push(this.$t(`country.${this.player.nationalityId2}`));
    }
    return result.filter(r => r).join(' / ');
  }

  filterByLeagueAndGameType(item: any) {
    // TODO filterByLeagueAndGameType
    // return (this.selectedLeagueId === 'all' || item.leagueId === this.selectedLeagueId)
    //   && (this.selectedGameTypeId === 'all' || item.gameTypeId === this.selectedGameTypeId);
  }

  // TODO mapMutations([selectLeagueId, selectGameTypeId, selectHomeAway]),


  loadPlayer() {
    PLAYER_SERVICE.playerById(this.playerId).then((response: any) => {
      this.player = new Player(response.data);
      this.loaded = true;
      this.origLeague = this.focusLeagueId;
      // TODO this.selectLeagueId('all');
      this.origGameType = this.focusGameTypeId;
      // TODO this.selectGameTypeId('all');
    });
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    try {
      if (to.params.playerId) {
        this.loadPlayer();
      }
    } finally {
      next();
    }
  }

}
